import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * BCP 47 locale tag for Intl APIs (dates, numbers) from the active admin language.
 */
export function resolveAdminLocaleTag(language: string | undefined): string {
  const lang = language ?? 'cs';
  if (lang.startsWith('cs')) {
    return 'cs-CZ';
  }
  if (lang.startsWith('en')) {
    return 'en-GB';
  }
  if (lang.startsWith('sk')) {
    return 'sk-SK';
  }
  return lang.replace('_', '-');
}

export function useAdminLocaleTag(): string {
  const { i18n } = useTranslation('admin');
  const language = i18n?.resolvedLanguage ?? i18n?.language;
  return useMemo(
    () => resolveAdminLocaleTag(language),
    [language]
  );
}
